import React, { useContext, useEffect } from 'react';
import { getClosestScreenWidth } from '../../../common/utilities/utils';
import CartPageItems from '../Presentation/CartPageItems';
import EmptyCartItems from '../Presentation/EmptyCartItems';
import { SET_COUPON_ERROR_MESSAGE, COUPON_STATIC_MSG } from 'organisms/CouponsLanding/Constants/CouponConstants';
import { UserOrderContext } from 'context/context';
import { modifyData } from 'organisms/CartPage/Utils/cartPageUtils';

const CartPageComponent = props => {
  const { contentData = {}, cartListContent, isModalOpen, confirmChangesHandler, dispositionData } = props || {};
  const { cartReducer, tenantReducer, segmentedHelpData } = contentData;
  const bucketSize = getClosestScreenWidth(window.innerWidth);
  const { componentOptions: { web: { global: { showPriceWithTax = false } = {} } = {} } = {} } = tenantReducer ?? {};
  let cartListData = {};
  if (cartReducer && cartReducer.cartData && cartListContent.length) {
    cartListData = modifyData(
      cartReducer.cartData,
      cartListContent,
      tenantReducer?.tenantId,
      tenantReducer?.currencyConversionFactor,
      tenantReducer?.addHope,
      tenantReducer?.carryBag,
      bucketSize,
      tenantReducer?.country,
    );
  }

  const { userOrderStateDispatch } = useContext(UserOrderContext);

  useEffect(() => {
    if (cartReducer?.cartData?.discountLines?.length === 0) {
      userOrderStateDispatch({
        type: SET_COUPON_ERROR_MESSAGE,
        value: { couponErrorMessage: '' },
      });
      localStorage.removeItem('expiryMessage');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartListData?.cartSummary?.quantity]);

  useEffect(() => {
    if (cartListData?.cartSummary?.discountAmounts[0]?.isError) {
      userOrderStateDispatch({
        type: SET_COUPON_ERROR_MESSAGE,
        value: { couponErrorMessage: COUPON_STATIC_MSG + cartListData?.cartSummary?.discountAmounts[0]?.errorMessages },
      });
      localStorage.removeItem('expiryMessage');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartListData?.cartSummary?.discountAmounts]);

  return cartListData.cartList ? (
    <CartPageItems
      contentData={cartListData}
      isModalOpen={isModalOpen}
      currencySymbol={tenantReducer.currencySymbol}
      currencyConversionFactor={tenantReducer.currencyConversionFactor}
      addHope={tenantReducer.addHope}
      carryBag={tenantReducer.carryBag}
      confirmChangesHandler={confirmChangesHandler}
      faqAndContactData={segmentedHelpData}
      tenantId={tenantReducer?.tenantId}
      maxItemCountPerLineItem={tenantReducer?.maxItemCountPerLineItem}
      dispositionData={dispositionData}
      history={props.history}
      showPriceWithTax={showPriceWithTax}
    />
  ) : (
    <EmptyCartItems contentData={cartListData} faqAndContactData={segmentedHelpData} history={props.history} />
  );
};

export default CartPageComponent;
